<template>
  <div class="feature-grid">
    <div
        v-for="(item, index) in featureList"
        :key="index"
        class="feature-card"
    >
      <div class="feature-img">
         <img :src="item.image"/>
      </div>
      <div class="feature-text">
        <h3 class="feature-title">{{ getItemTitle(item) }}</h3>
        <p class="feature-desc">{{ getItemDesc(item) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeatureGrid',
  props: {
    featureList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getItemTitle(item) {
      return item.titleKey ? this.$t(item.titleKey) : item.title
    },
    getItemDesc(item) {
      return item.descKey ? this.$t(item.descKey) : item.desc
    }
  }
}
</script>

<style scoped>
.feature-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin: 0 auto;
  background: #F8F9FA;
  width: calc(100% - 60vh);
}

.feature-card {
  display: flex;
  flex-direction: column;
  background: #fff;
  overflow: hidden;
}

.feature-img {
  width: 100%;
  height: 24vh;
  background-color: #e0e0e0;
  >img{
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
}

.feature-text {
  padding: 3.5vh 2.8vh;
  text-align: center;
}

.feature-title {
  margin: 0 0 1.8vh;
  font-size: 1.5vw;
  font-weight: 600;
  color: #222;
}

.feature-desc {
  margin: 0;
  font-size: 1vw;
  line-height: 1.65;
  color: #666;
  text-align: left;
}

@media (max-width: 768px) {
  .feature-grid {
    grid-template-columns: 1fr;
  }
  .feature-img {
    height: 200px;
  }
  .feature-text {
    padding: 28px 20px;
  }
  .feature-title {
    font-size: 18px;
  }
}
</style>